module.exports = __webpack_public_path__ + "images/78815cd8c58807df0e3dfb8bd7ec8237-logo.png";